import type { RefObject } from 'react';
import type { CaseHeaderLayoutState } from './CaseHeader.data';
import { findTransitionController } from '../../../util/core-transition-component';
import { revealRectangle } from '../../../util/animation/reveal/reveal';

interface CaseHeaderRefs {
  titleRef: RefObject<HTMLHeadingElement | null>;
  clientTitleRef: RefObject<HTMLHeadingElement | null>;
  descriptionRef: RefObject<HTMLElement | null>;
  layoutState: CaseHeaderLayoutState;
  mediaWrapperRef: RefObject<HTMLDivElement | null>;
  mediaInnerHolderRef: RefObject<HTMLDivElement | null>;
  setCanCitiesNavigationTransitionIn: React.Dispatch<React.SetStateAction<boolean>>;
  skipTransitionIn: boolean;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  {
    titleRef,
    descriptionRef,
    clientTitleRef,
    layoutState,
    skipTransitionIn,
    mediaWrapperRef,
    mediaInnerHolderRef,
    setCanCitiesNavigationTransitionIn,
  }: CaseHeaderRefs,
): void {
  if (layoutState === 'previewNext') {
    if (mediaWrapperRef?.current) {
      timeline.add(revealRectangle(mediaWrapperRef.current), 0);
    }

    if (mediaInnerHolderRef.current) {
      timeline.fromTo(
        mediaInnerHolderRef.current,
        { scale: 1.2 },
        {
          scale: 1,
          duration: 1,
          ease: 'Power3.easeInOut',
          clearProps: 'scale',
        },
        0,
      );
    }

    timeline.fromTo(titleRef.current, { scale: 0.61 }, { duration: 1, scale: 1 }, 0);
    timeline.fromTo(descriptionRef.current, { scale: 0.75 }, { duration: 1, scale: 1 }, 0);
  } else if (!skipTransitionIn) {
    const clientTitleController = findTransitionController(clientTitleRef);
    const titleController = findTransitionController(titleRef);
    const descriptionTitleController = findTransitionController(descriptionRef);

    if (mediaInnerHolderRef.current) {
      timeline.fromTo(
        mediaInnerHolderRef.current,
        { scale: 1.2 },
        {
          scale: 1,
          duration: 0.8,
          ease: 'Power3.easeInOut',
          clearProps: 'scale',
        },
        0,
      );
    }

    if (mediaWrapperRef?.current) {
      timeline.add(revealRectangle(mediaWrapperRef.current), 0);
    }

    timeline.addLabel('startText', '>-0.4');
    timeline.add(clientTitleController?.getTimeline('in') as gsap.core.Timeline, 'startText');
    timeline.add(titleController?.getTimeline('in') as gsap.core.Timeline, 'startText+=0.1');
    timeline.add(descriptionTitleController?.getTimeline('in') as gsap.core.Timeline, '<0.2');
    timeline.call(setCanCitiesNavigationTransitionIn, [true], '<0.1');
  } else if (skipTransitionIn) {
    const clientTitleController = findTransitionController(clientTitleRef);
    timeline.add(clientTitleController?.getTimeline('in') as gsap.core.Timeline, 0);
  }
}
